import { addBreadcrumb, captureException } from "@sentry/nextjs";
import { BaseJobPost, JobPost } from "types/models";

import { getJobPostLocation } from "../helpers";

export const buildJobPostKeywords = (jobPosts: JobPost[] | BaseJobPost[]) => {
  try {
    if (!jobPosts?.length) return;

    addBreadcrumb({
      message: "buildJobPostKeywords",
      data: {
        jobPosts,
      },
    });

    const industryKeywords = jobPosts.map((jobPost) => `${jobPost.industry?.name || jobPost.title} jobs`);

    const locationKeywords = jobPosts.map((jobPost) => `${getJobPostLocation(jobPost)} jobs`);

    return Array.from(new Set(industryKeywords.concat(locationKeywords)));
  } catch (error) {
    captureException(error);
    return [];
  }
};
